<template>
  <div class="portfolio-item">
    <img :src="src">
  </div>
</template>

<script>
export default {
  name: 'portfolio-item',
  props: ['src', 'caption'],
}
</script>

<style lang="scss">
  .portfolio-item {
    padding-bottom: 1rem;
    text-align: center;
    img {
      display: inline-block;
      max-width: 100%;
      max-height: 250px;
    }
  }
</style>



// WEBPACK FOOTER //
// PortfolioItem.vue?3e452960